import { createContext, useContext, useState, useEffect } from 'react';

const VotacaoContext = createContext();

function VotacaoProvider({ children }) {
  // Inicializa o estado com o valor do localStorage ou false como padrão
  const [votacaoConcluida, setVotacaoConcluidaState] = useState(() => {
    const saved = localStorage.getItem('votacaoConcluida');
    return saved ? JSON.parse(saved) : false;
  });

  // Wrapper para setVotacaoConcluida que também salva no localStorage
  const setVotacaoConcluida = (value) => {
    setVotacaoConcluidaState(value);
    localStorage.setItem('votacaoConcluida', JSON.stringify(value));
  };

  // Sincroniza com localStorage quando o componente monta
  useEffect(() => {
    const saved = localStorage.getItem('votacaoConcluida');
    if (saved) {
      setVotacaoConcluidaState(JSON.parse(saved));
    }
  }, []);

  const value = {
    votacaoConcluida,
    setVotacaoConcluida,
  };

  return <VotacaoContext.Provider value={value}>{children}</VotacaoContext.Provider>;
}

// Hook personalizado para usar o contexto
function useVotacao() {
  const context = useContext(VotacaoContext);
  if (!context) {
    throw new Error('useVotacao deve ser usado dentro de um VotacaoProvider');
  }
  return context;
}

export { VotacaoProvider, useVotacao };
